import { data } from '../../svg/AddTask/data';
import { makeIcon } from '../makeIcon';

export const AddTask = makeIcon(data, 'add_task', 'AddTask');

export default AddTask;
